// removed by extract-text-webpack-plugin
module.exports = {"filterBox":"_28A5","searchBox":"_81nO","createButton":"_23M6"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Services/HostedVoice/HostedVoiceServicesList/HostedVoiceServicesList.scss
// module id = oOB6
// module chunks = 0